module.exports = __webpack_public_path__ + "static/media/multiuser.a1ea2d16.svg";